import styled from 'styled-components'
import breakpoint from 'components/breakpoint'

const LogisterFormSocialButtonsContainer = styled.div`
  & > button {
    margin-bottom: 20px;
    margin-right: 20px;
    flex-basis: calc(50% - 10px);
    flex-shrink: 0;
  }

  &:last-child > button:last-of-type {
    margin-bottom: 0;
  }

  ${breakpoint('landscape')`
    display: flex;
    justify-content: flex-start;

    &:last-child > button {
      margin-bottom: 0;
    }
  `};
`

export default LogisterFormSocialButtonsContainer
